import { useState, type ReactElement } from "react";
import {
  Text,
  Box,
  Stack,
  Tabs,
  PhoneIcon,
  PersonIcon,
  DeliveryIcon,
  type TabItem,
} from "@citibox-panel/ui";

// Interactive demo for the Tabs wrapper: the enclosed variant mimics the
// search-shell's hierarchy-1 tabs (rich label + close), the pill variant its
// hierarchy-2 sub-tabs (a permanent one + closable ones).
export function TabsDemo(): ReactElement {
  const [enclosed, setEnclosed] = useState<TabItem[]>([
    {
      value: "600111222",
      label: (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            textAlign: "left",
          }}
        >
          <PhoneIcon fontSize="small" />
          <span>
            Lucía Fernández
            <br />
            <small>+34 612 348 902</small>
          </span>
        </Box>
      ),
      closable: true,
    },
    {
      value: "600999000",
      label: (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            textAlign: "left",
          }}
        >
          <PhoneIcon fontSize="small" />
          <span>
            Carlos Ruiz
            <br />
            <small>+34 678 221 540</small>
          </span>
        </Box>
      ),
      closable: true,
    },
  ]);
  const [enclosedValue, setEnclosedValue] = useState("600111222");

  const [pill, setPill] = useState<TabItem[]>([
    {
      value: "user",
      label: (
        <Box
          component="span"
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
        >
          <PersonIcon fontSize="small" /> Usuario
        </Box>
      ),
    },
    {
      value: "a3f1d740",
      label: (
        <Box
          component="span"
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
        >
          <DeliveryIcon fontSize="small" /> Entrega a3f1…d740
        </Box>
      ),
      closable: true,
    },
  ]);
  const [pillValue, setPillValue] = useState("user");

  return (
    <>
      <Text variant="body2" color="secondary" gutterBottom>
        Pestañas de dos jerarquías: <code>enclosed</code> (búsquedas, estilo
        pestaña) y <code>pill</code> (entidades). Cierre por item con la X.
      </Text>
      <Stack spacing={3}>
        <div>
          <Text variant="subtitle2" component="h3" gutterBottom>
            variant: enclosed (jerarquía 1 — búsquedas, cerrables)
          </Text>
          <Tabs
            items={enclosed}
            value={enclosedValue}
            onChange={setEnclosedValue}
            variant="enclosed"
            onClose={(value) => {
              setEnclosed((tabs) => tabs.filter((t) => t.value !== value));
            }}
          />
        </div>
        <div>
          <Text variant="subtitle2" component="h3" gutterBottom>
            variant: pill (jerarquía 2 — Usuario fijo + Entrega cerrable)
          </Text>
          <Tabs
            items={pill}
            value={pillValue}
            onChange={setPillValue}
            variant="pill"
            onClose={(value) => {
              setPill((tabs) => tabs.filter((t) => t.value !== value));
            }}
          />
        </div>
      </Stack>
    </>
  );
}
